export const TeamsMeetingColors = {
  green300: '#6BB700',
  green400: '#13A10E',
  green600: '#237B4B',
};
